import React from 'react'

import IconButton from '@material-ui/core/IconButton'
import { withStyles } from '@material-ui/core/styles'
import Tooltip from '@material-ui/core/Tooltip'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

const styles = theme => ({
  toggleAllGroupsButton: {
    marginTop: 6,
    marginRight: 6,
    float: 'right'
  },
  collapseImage: {
    height: 20
  }
})

class ToggleAllGroupsButton extends React.PureComponent {
  constructor (props) {
    super(props)
    const { classes, toggleAllGroups } = props
    this.pure = {}
    this.pure.toggleMarkup =
      <IconButton className={classes.toggleAllGroupsButton} aria-label="Collapse/expand all groups" onClick={toggleAllGroups}>
        <Tooltip title="Collapse/expand all groups" disableTouchListener={true} disableFocusListener={true}>
          <img className={classes.collapseImage} src="img/the-noun-project/noun_collapse_2286593.svg" alt="Collapse/expand all groups" />
        </Tooltip>
      </IconButton>
  }

  render () {
    return (
      this.pure.toggleMarkup
    )
  }
}

ToggleAllGroupsButton.propTypes = {
  classes: PropTypes.object.isRequired,
  toggleAllGroups: PropTypes.func.isRequired
}

function mapStateToProps (state, ownProps) {
  return {}
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ToggleAllGroupsButton)
  )
)
